import React, { MouseEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TaxType } from "../../../configs/constants/TaxType";
import { Price } from "../../../models/Contract";
import AppInput from "../../Core/AppInput/AppInput";
import AppText from "../../Core/AppText/AppText";
import Button, { ButtonStyleProps } from "../../Core/Button/Button";
import Checkbox from "../../Core/Checkbox/Checkbox";
import Flex from "../../Layout/Flex";

interface RutRotSettingModalStyles {
	primaryActionButton?: ButtonStyleProps;
	secondaryActionButton?: ButtonStyleProps;
}

interface Props {
	title: string;
	priceRow: Price;
	onSubmit: (updatedRutRotSettings: Price["taxRutRot"]) => any;
	onCancel: () => any;
}

const RutRotSettingModal: React.FC<Props> = ({ title, priceRow, onSubmit, onCancel }) => {
	const { t } = useTranslation();

	const defaultRotValue = 50;
	const defaultRutValue = 30;

	const [isRot, setIsRot] = useState(false);
	const [isRut, setIsRut] = useState(false);

	const [rutValue, setRutValue] = useState<number>(defaultRotValue);
	const [rotValue, setRotValue] = useState<number>(defaultRutValue);

	useEffect(() => {
		if (priceRow.taxRutRot?.type === TaxType.ROT) {
			const rotValue: number = Number(priceRow.taxRutRot.percentage);
			setRotValue(rotValue);
			setIsRot(true);
			setIsRut(false);
		}

		if (priceRow.taxRutRot?.type === TaxType.RUT) {
			const rutValue: number = Number(priceRow.taxRutRot.percentage);
			setRutValue(rutValue);
			setIsRut(true);
			setIsRot(false);
		}
	}, [priceRow]);

	const handleRutCheckbox = (e: any) => {
		setIsRut(e.target.checked);
		setIsRot(false);
	};

	const handelRotCheckbox = (e: any) => {
		setIsRot(e.target.checked);
		setIsRut(false);
	};

	const handleRutValue = (e: any) => {
		setRutValue(e.target.value);
	};

	const handleRotValue = (e: any) => {
		setRotValue(e.target.value);
	};

	function handleSubmit(e: MouseEvent<any>) {
		e.preventDefault();
		if (!isRot && !isRut) {
			onSubmit(undefined);
		} else {
			onSubmit({
				type: isRot ? TaxType.ROT : TaxType.RUT,
				percentage: Number(isRot ? rotValue : rutValue),
			});
		}
	}

	return (
		<ModalContainer>
			<ModalWrapper>
				<AppText size="xm" weight="bold">
					{title}
				</AppText>
				<Flex margin="1.5rem 0" direction="column">
					<Flex alignItems="center" justifyContent="center">
						<Checkbox
							isChecked={isRut}
							value={isRut}
							onChange={(e: any) => handleRutCheckbox(e)}
							label="contract.rutRot.forRut"
						/>
						<AppInput
							type="number"
							onChange={(e: any) => handleRutValue(e)}
							value={rutValue}
							containerMargin="0.3rem 0 0 1rem"
							containerWidth="50px"
							textAlign="center"
						/>
						<AppText>&nbsp; %</AppText>
					</Flex>
					<Flex alignItems="center" justifyContent="center">
						<Checkbox
							isChecked={isRot}
							value={isRot}
							onChange={(e: any) => handelRotCheckbox(e)}
							label="contract.rutRot.forRot"
						/>
						<AppInput
							type="number"
							onChange={(e: any) => handleRotValue(e)}
							value={rotValue}
							containerMargin="0.3rem 0 0 1rem"
							containerWidth="50px"
							textAlign="center"
						/>
						<AppText>&nbsp; %</AppText>
					</Flex>
				</Flex>

				<Button width="12.625rem" margin="0 0 0.5rem 0" onClick={handleSubmit}>
					{t("SAVE")}
				</Button>
				<Button backgroundColor="secondary" width="12.625rem" onClick={onCancel}>
					{t("CANCEL")}
				</Button>
			</ModalWrapper>
		</ModalContainer>
	);
};

export default RutRotSettingModal;

const ModalContainer = styled.div`
	position: fixed;
	z-index: 1000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	background: rgba(0, 0, 0, 0.6);
	overflow-y: auto;
`;

const ModalWrapper = styled.section`
	background: white;
	width: 100%;
	max-width: 32.5rem;
	margin: 10em auto 5em auto;
	height: auto;
	align-items: center;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	padding: 3.125rem;
`;
